import coverImg from "assets/images/v132/cover.webp"
import titleImg from "assets/images/v132/title.webp"

export const v132Config = {
  cover: {
    en: coverImg,
  },
  title: {
    en: titleImg,
  },
}
